var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo } from 'react';
import { createGlobalStyle, ThemeProvider as SCThemeProvider } from 'styled-components';
import semanticColors from './semanticColors';
var CSS_SEMANTIC_VARIABLE_PROPERTY = 'cookbook-colors';
var createCssTheme = function (theme, customPropertyName) {
    if (customPropertyName === void 0) { customPropertyName = CSS_SEMANTIC_VARIABLE_PROPERTY; }
    var cssTheme = Object.entries(theme)
        .map(function (_a) {
        var _b = __read(_a, 2), semanticColorName = _b[0], color = _b[1];
        return "--".concat(customPropertyName, "-").concat(semanticColorName, ": ").concat(color, ";");
    })
        .join('\n');
    return cssTheme;
};
var GlobalThemeStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :root {\n    ", "\n  }\n\n  ", "\n"], ["\n  :root {\n    ", "\n  }\n\n  ", "\n"])), createCssTheme(semanticColors['light']), function (_a) {
    var themeMode = _a.themeMode;
    return "body[data-cb-theme='".concat(themeMode, "'] {\n      ").concat(createCssTheme(semanticColors[themeMode]), "\n    }\n  ");
});
/**
 * @deprecated use CookbookProvider instead.
 * @see https://github.com/creditornot/wolt-cookbook/blob/feat/CookbookProvider/packages/ingredients/docs/ThemeProvider-to-CookbookProvider-migration-guide.md
 */
export var ThemeProvider = function (_a) {
    var children = _a.children, _b = _a.direction, direction = _b === void 0 ? 'ltr' : _b, _c = _a.themeMode, themeMode = _c === void 0 ? 'light' : _c;
    var theme = useMemo(function () { return ({
        cbDirection: direction,
        cbThemeMode: themeMode,
        cbSemanticColors: semanticColors[themeMode],
    }); }, [direction, themeMode]);
    useEffect(function () {
        document.body.setAttribute('data-cb-theme', themeMode);
    }, [themeMode]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalThemeStyles, { themeMode: themeMode }),
        React.createElement(SCThemeProvider, { theme: theme }, children)));
};
/**
 * A helper method for getting the CSS-variable for a semantic color.
 *
 * E.g. `cssVariableThemedValue('textPrimary')`, would return `--cookbook-colors-textPrimary`,
 * where `cookbook-colors` is the theme's variable property.
 *
 * @deprecated use `semanticCbCssVars` instead
 */
export var cssVariableThemedValue = function (color) {
    return "--".concat(CSS_SEMANTIC_VARIABLE_PROPERTY, "-").concat(color);
};
/**
 * @deprecated use logical CSS attributes and [dir="rtl"] selector instead
 */
export var cssDirectionalValue = function (value) {
    return function (_a) {
        var _b = _a.theme.cbDirection, cbDirection = _b === void 0 ? 'ltr' : _b;
        return value[cbDirection];
    };
};
var templateObject_1;
//# sourceMappingURL=ThemeProvider.js.map